












































































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {AdminConfig} from '@/model/resource/AdminConfig'
import {InputAdminConfigSchema} from '@/schema/resource/AdminConfig/InputAdminConfigSchema'

@Component
export default class PersistAdminConfigView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputAdminConfigSchema()
  adminConfig = new AdminConfig()

  Helper = Helper

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.adminConfig.getAdminConfig(id)
    }

    $.await.done('getAdminConfig')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.adminConfig.persistAdminConfig()
    await Helper.success('system.success.persist')
  }

  get characterCount() {
    const maxLength = 255
    return `${this.adminConfig.boasVindas?.length || 0}/${maxLength}`
  }
}
